export const SUBMISSION_KEY = 'lf:submission'
export const SHAPE_KEY_PREFIX = 'lf:shape:'
export const TOKEN_PARAM = 'lfs'
export const SUBMISSION_TTL_MS = 7 * 24 * 60 * 60 * 1000

export type StoredSubmission = {
  token: string
  values: Record<string, string>
  savedAt: number
}

function storage(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function readJson<T>(key: string): T | null {
  try {
    const raw = storage()?.getItem(key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    storage()?.setItem(key, JSON.stringify(value))
  } catch {
    // modo privado ou cota cheia: seguimos sem persistir
  }
}

export function removeKey(key: string): void {
  try {
    storage()?.removeItem(key)
  } catch {
    // idem
  }
}

export function readSubmission(): StoredSubmission | null {
  const stored = readJson<StoredSubmission>(SUBMISSION_KEY)
  if (!stored || typeof stored.token !== 'string' || !stored.token) return null
  if (typeof stored.savedAt !== 'number' || Date.now() - stored.savedAt > SUBMISSION_TTL_MS) {
    removeKey(SUBMISSION_KEY)
    return null
  }
  return stored
}

export function saveSubmission(token: string, values: Record<string, string>): void {
  writeJson(SUBMISSION_KEY, { token, values, savedAt: Date.now() } satisfies StoredSubmission)
}
